<template>
<main class="c-ir-reports-page">
    <Container>
        <Row class="c-ir-reports-page__top">
            <Column><Heading isCategory v-epi-edit="'Label'">{{model.label}}</Heading></Column>
            <Column><Heading :level="3" noMarginTop v-epi-edit="'Title'">{{model.title}}</Heading></Column>
        </Row>
        <ExpandableListBlock v-epi-edit="'ExpandableListBlock'" class="c-ir-reports-page__reports" v-bind="model.expandableListBlock.content"/>
    </Container>
</main>
</template>

<script>
export default {
    props: {
        model: Object
    }
};
</script>

<style lang="scss">
.c-ir-reports-page {
    &__reports {
        margin-bottom: 2rem;

        @include media-md {
            margin-bottom: 5rem;
        }
    }
}
</style>
